import React, { Component } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import IniciarSesion from './Paginas/inicioSesion'
import Registro from './Paginas/registrarse'
import Inicio from './Paginas/Admin/inicio'
import history from './historial'
import Consultar from './Paginas/Admin/consultar'
import Digitalizar from './Paginas/Admin/digitalizar'
import Configuraciones from './Paginas/Admin/configuraciones'
import Validar from './Paginas/Admin/validar'
import ValidarAspirante from './Paginas/Admin/validarAspirantes'
import PaginaNoEncontrada from './Paginas/pnf'
import NoAutorizado from './Paginas/noAutorizado'
import OpcionesAdmin from './Paginas/Admin/opcionesAdmin'
import AdminAutorizaciones from './Paginas/Admin/adminAutorizaciones'
import AdminUsuarios from './Paginas/Admin/adminUsuarios'
import AdminModulo from './Paginas/Admin/adminModulo'
import AdminDocs from './Paginas/Admin/adminDocs'
import AdminEstudiante from './Paginas/Admin/adminEstudiantes'
import AdminRegistroActividad from './Paginas/Admin/adminRegistroActividad'
import AdminGrupos from './Paginas/Admin/adminGrupos'
import PrimerInicio from './Paginas/Admin/primerInicio'
import { ProtectToLogIn, ProtectExternal, ProtectAspirante } from './protectRoute'
import { toast, } from 'react-toastify'
import Fetch from './Auxiliares/fetch'
import AspiranteSesion from './Paginas/Aspirantes/aspiranteSesion'
import AspiranteInicio from './Paginas/Aspirantes/aspiranteInicio'
import AspiranteSubirDocumentos from './Paginas/Aspirantes/aspiranteSubirDocumentos'
import AspiranteEstadoDocumentos from './Paginas/Aspirantes/aspiranteEstadoDocumentos'
import AspirantePago from './Paginas/Aspirantes/aspirantePago'
import AdminAspirante from './Paginas/Admin/adminAspirante'
import AspiranteNuevoIngreso from './Paginas/Aspirantes/aspiranteNuevoIngreso'
import AdminReporteador from './Paginas/Admin/adminReporteador'
import AdminConvocatoria from './Paginas/Admin/adminConvocatoria'
import SubirABaseDatos from './Paginas/Admin/subirABaseDatos'
import AdminFunciones from './Paginas/Admin/adminFunciones'

export default class Enrutamiento extends Component {
    constructor(props) {
        super(props);
        this.remove = this.remove.bind(this)
    }

    componentWillMount() {
        if (localStorage.getItem('token')) {
            Fetch('/api/auth', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => {
                    const data = response.data;
                    sessionStorage.setItem('_id', data._id);
                    sessionStorage.setItem('nombre', data.nombre);
                    sessionStorage.setItem('ap_paterno', data.ap_paterno);
                    sessionStorage.setItem('ap_materno', data.ap_materno);
                    sessionStorage.setItem('rol', data.rol);
                    sessionStorage.setItem('usuario', data.usuario);
                    sessionStorage.setItem('grupo', data.grupo)
                })
                .catch(err => {
                    switch (err.status) {
                        case 401:
                            toast.error('Esta sesion ha caducado')
                            this.remove()
                            break;

                        case 600:
                            toast.error('Error inesperado')
                            this.remove()
                            break;

                        case 602:
                            toast.error('Usuario no encontrado')
                            this.remove()
                            break;

                        default:
                            toast.error(err)
                            this.remove()
                            break;
                    }
                })
        }

        if(localStorage.getItem('AspiranteToken')){
            Fetch('/api/aspiranteAuth', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => {
                    const data = response.data;
                    sessionStorage.setItem('_id', data._id);
                    sessionStorage.setItem('nombre', data.nombre);
                    sessionStorage.setItem('ap_paterno', data.ap_paterno);
                    sessionStorage.setItem('ap_materno', data.ap_materno);
                    sessionStorage.setItem('curp', data.curp);
                    sessionStorage.setItem('ficha', data.ficha);
                    sessionStorage.setItem('pago', data.pago)
                   
                })
                .catch(err => {
                    switch (err.status) {
                        case 401:
                            toast.error('Esta sesion ha caducado')
                            this.remove()
                            break;

                        case 600:
                            toast.error('Error inesperado')
                            this.remove()
                            break;

                        case 602:
                            toast.error('Usuario no encontrado')
                            this.remove()
                            break;

                        default:
                            toast.error(err)
                            this.remove()
                            break;
                    }
                })
            }
        }

    remove() {
        localStorage.clear()
        sessionStorage.clear()
        history.push('/')
    }

    render() {
        return (
            <Router history={history}>
                <Switch>
                    <ProtectExternal exact path={"/"} component={AspiranteSesion} />
                    <ProtectExternal path={"/iniciarSesion"} component={IniciarSesion} />
                    <ProtectExternal path={"/registro"} component={Registro} />
                    <ProtectToLogIn path="/inicio" component={Inicio} />
                    <ProtectToLogIn path="/consultar" component={Consultar} />
                    <ProtectToLogIn path="/digitalizar" component={Digitalizar} />
                    <ProtectToLogIn exact path="/validar" component={Validar} />
                    <ProtectToLogIn path="/validar/aspirantes" component={ValidarAspirante} />
                    <ProtectToLogIn path="/configuraciones" component={Configuraciones} />
                    <ProtectToLogIn exact path="/admin" component={OpcionesAdmin} />
                    <ProtectToLogIn path="/admin/pendientes" component={AdminAutorizaciones} />
                    <ProtectToLogIn path="/admin/usuarios" component={AdminUsuarios} />
                    <ProtectToLogIn path="/admin/modulos" component={AdminModulo} />
                    <ProtectToLogIn path="/admin/docs" component={AdminDocs} />
                    <ProtectToLogIn path="/admin/estudiantes" component={AdminEstudiante} />
                    <ProtectToLogIn path="/admin/registroActividad" component={AdminRegistroActividad} />
                    <ProtectToLogIn path="/admin/grupos" component={AdminGrupos} />
                    <ProtectToLogIn path="/admin/aspirantes" component={AdminAspirante} />
                    <ProtectToLogIn path="/admin/reporteador" component={AdminReporteador} />
                    <ProtectToLogIn path="/admin/convocatoria" component={AdminConvocatoria} />
                    <ProtectToLogIn path="/admin/subirABaseDatos" component={SubirABaseDatos} />
                    <ProtectToLogIn path="/admin/funciones" component={AdminFunciones} />
                    <ProtectExternal path="/primerInicio" component={PrimerInicio} />
                    <ProtectExternal path="/aspiranteSesion" component={AspiranteSesion} />
                    <ProtectAspirante path="/aspiranteInicio" component={AspiranteInicio} />
                    <ProtectAspirante path="/aspiranteSubirDocumentos" component={AspiranteSubirDocumentos} />
                    <ProtectAspirante path="/aspiranteEstadoDocumentos" component={AspiranteEstadoDocumentos} />
                    <ProtectAspirante path="/aspirantePago" component={AspirantePago} />
                    <ProtectAspirante path="/aspiranteNuevoIngreso" component={AspiranteNuevoIngreso} />
                    <Route path="/noAutorizado" component={NoAutorizado} />
                    <Route component={PaginaNoEncontrada} />
                </Switch>
            </Router>
        );
    }
}